__turbopack_context__.v({
  "chatContent": "ClientChatContent-module__DoupZW__chatContent",
  "chatContent__container": "ClientChatContent-module__DoupZW__chatContent__container",
  "chatContent__containerAdvisor": "ClientChatContent-module__DoupZW__chatContent__containerAdvisor",
  "chatContent__containerPlaceholder": "ClientChatContent-module__DoupZW__chatContent__containerPlaceholder",
  "chatContent__containerPlaceholderAdvisor": "ClientChatContent-module__DoupZW__chatContent__containerPlaceholderAdvisor",
  "chatContent__footer": "ClientChatContent-module__DoupZW__chatContent__footer",
  "chatContent__footer__buttonGroup": "ClientChatContent-module__DoupZW__chatContent__footer__buttonGroup",
  "chatContent__footer__thread": "ClientChatContent-module__DoupZW__chatContent__footer__thread",
  "chatFadeIn": "ClientChatContent-module__DoupZW__chatFadeIn",
});
